import {pick, omit} from '@lsfe/tools';

const objectToTree = (obj, pickKeys, isTop = false) => {
    if (obj.children) {
        return obj;
    }
    const data = omit(obj, pickKeys);
    const children = Object.keys(data).map(item => objectToTree(obj[item], pickKeys));
    if (isTop) {
        return children;
    }
    return {
        ...pick(obj, pickKeys),
        children
    };
};

export const formatToTree = (data, config, options) => {
    if (!data || !data.length || !config || !Array.isArray(config) || !config.length) {
        return [];
    }
    const groupMap = {};
    config = [...config];
    // 把最后一个配置单独拿出来
    const lastConfig = config.splice(config.length - 1, 1)[0];
    const {idWithLevel} = options;
    let lastTempMap = {};
    data.forEach(item => {
        let temp = groupMap;
        let level = 0;
        config.forEach(item2 => {
            const itemId = idWithLevel ? `${level}${item[item2.idName]}` : item[item2.idName];
            if (!temp[itemId]) {
                // 如果不存在，添加一下。已经存在，就不用处理了。
                temp[itemId] = {
                    _parentId: temp.id,
                    id: itemId,
                    label: item2.labelRender ? item2.labelRender(item) : item[item2.labelName]
                };
            }
            level += 1;
            temp = temp[itemId];
        });
        const lastData = {
            ...item,
            _parentId: temp.id,
            id: idWithLevel ? `${level}${item[lastConfig.idName]}` : item[lastConfig.idName],
            label: lastConfig.labelRender ? lastConfig.labelRender(item) : item[lastConfig.labelName]
        };
        // 判断一下是否已经存在值相同的节点
        if (lastTempMap[lastData.id]) {
            return;
        }
        lastTempMap[lastData.id] = true;
        if (!temp.children) {
            temp.children = [lastData];
        } else {
            temp.children.push(lastData);
        }
    });
    if (!config.length) {
        // config只有一层，在splice后，长度为空
        // 直接返回列表
        return groupMap.children;
    }
    return objectToTree(groupMap, ['id', 'label', '_parentId'], true);
};
